import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { getEnvironment } from './services/homeservice';
import { ConfigProvider } from 'antd';
import MenuBookLayout from './components/layouts/menubooklayout';
import Home from './pages/home';
import { Kioskpageversion } from './pages/kioskpageversion';
import MenuItems from './pages/menuitems';
import Stores from './pages/stores';
import PageVersions from './pages/pageversions';
import { AddOns } from './components/addons/addons'; // ToDo: Move component under pages directory
import { MenuOptions } from './components/menuOptions/menuoptions'; // ToDo: Move component under pages directory
import Attractor from './pages/attractor';
import PageVersionApprovalRequests from './pages/pageversionapprovals';
import ReviewApproval from './pages/reviewapproval';
import SimulatorPreview from './pages/simulatorpreview';
import Users from './pages/users';
import Roles from './pages/roles';
import OutOfStock from './pages/outofstock';
import { GlobalLoadingProvider } from './components/common/globalloadingcontext';
import DeviceManagementPage from './pages/devicemanagement';
import DeviceDetailsPage from './pages/devicedetailspage';
import ItemBlockPage from './pages/itemblock';
import Languages from './pages/languages';
import Currencies from './pages/currencies';
import { LoginCallback } from '@okta/okta-react';
import NutrigenUpcLinks from './pages/nutrigenupclinks';
import ForcedUpsell from './pages/upsell/forcedupsell';
import TriggeredUpsell from './pages/upsell/triggeredupsell';
import AnalyticsSessionsPage from './pages/analyticsSessions';
import AnalyticsInsightsPage from './pages/analyticsInsights';
import AnalyticsHeatmapPage from './pages/analyticsHeatmap';

const App: React.FC = () => {
  const [environment, setEnvironment] = useState<string>("");

  useEffect(() => {
    getEnvironment()
      .then(res => setEnvironment(res.environment))
      .catch(err => console.error("Failed to fetch environment", err));
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          green: '#549136',
        },
        components: {
          Tree: {
            colorBgContainer: 'transparent',
          },
          Menu: {
            darkItemBg: 'var(--color-primary)',
            darkItemSelectedBg: 'transparent',
            darkSubMenuItemBg: 'var(--color-primary)',
            darkItemHoverBg: '#776ef0',
            darkPopupBg: 'var(--color-primary)',
          },
        },
      }}
    >
      <GlobalLoadingProvider>
        <div className='-fluid'>
          <Routes>
            <Route path="/login/callback" element={<LoginCallback />} />
            <Route path="/attractor" element={<MenuBookLayout><Attractor /></MenuBookLayout>} />
            <Route path="/" element={<MenuBookLayout><Home /></MenuBookLayout>} />
            <Route path="/:id" element={<Home />} />
            <Route path="kioskpageversion/:id?" element={
              <MenuBookLayout><Kioskpageversion hasUnsavedChanges={false} handleUnsavedChanges={() => { }} /></MenuBookLayout>
            } />
            <Route path="pageversions" element={<MenuBookLayout><PageVersions /></MenuBookLayout>} />
            <Route path="menuoptiongroup" element={<MenuBookLayout><MenuOptions /></MenuBookLayout>} />
            <Route path="addons" element={<MenuBookLayout><AddOns /></MenuBookLayout>} />
            <Route path="/menuitems" element={<MenuBookLayout><MenuItems /></MenuBookLayout>} />
            <Route path="/stores" element={<MenuBookLayout><Stores /></MenuBookLayout>} />
            <Route path="/approvals" element={<MenuBookLayout><PageVersionApprovalRequests /></MenuBookLayout>} />
            <Route path="/approvals/review/:id" element={<MenuBookLayout><ReviewApproval /></MenuBookLayout>} />
            <Route path="/simulator/:pageversionguid" element={<MenuBookLayout><SimulatorPreview /></MenuBookLayout>} />
            <Route path="/users" element={<MenuBookLayout><Users /></MenuBookLayout>} />
            <Route path="/roles" element={<MenuBookLayout><Roles /></MenuBookLayout>} />
            <Route path="/devices" element={<MenuBookLayout><DeviceManagementPage /></MenuBookLayout>} />
            <Route path="/devices/:deviceId" element={<MenuBookLayout><DeviceDetailsPage /></MenuBookLayout>} />
            <Route path="/outofstock" element={<MenuBookLayout><OutOfStock /></MenuBookLayout>} />
            <Route path="/itemblock" element={<MenuBookLayout><ItemBlockPage /></MenuBookLayout>} />
            <Route path="/languages" element={<MenuBookLayout><Languages /></MenuBookLayout>} />
            <Route path="/currencies" element={<MenuBookLayout><Currencies /></MenuBookLayout>} />
            <Route path="/nutrigenupclinks" element={<MenuBookLayout><NutrigenUpcLinks /></MenuBookLayout>} />
            <Route path="/upsell/forced" element={<MenuBookLayout><ForcedUpsell /></MenuBookLayout>} />
            {environment === "DEV" && (
              <Route path="/upsell/triggered" element={<MenuBookLayout><TriggeredUpsell /></MenuBookLayout>} />
            )}
            <Route path="/analytics/sessions" element={<MenuBookLayout><AnalyticsSessionsPage /></MenuBookLayout>} />
            <Route path="/analytics/insights" element={<MenuBookLayout><AnalyticsInsightsPage /></MenuBookLayout>} />
            <Route path="/analytics/heatmap" element={<MenuBookLayout><AnalyticsHeatmapPage /></MenuBookLayout>} />
          </Routes>
        </div>
      </GlobalLoadingProvider>
    </ConfigProvider>
  );
};

export default App;
